import Collapse from 'components/collapse/Collapse';
import TextField from 'components/forms/textField/TextField';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const CommissionFields = () => {
  const { t } = useTranslation();

  const hasLinkedOwner = !!useWatch({
    name: 'linkedOwnerUid',
  });

  return (
    <fieldset
      disabled={hasLinkedOwner}
      data-testid="commission-and-communication-fields"
    >
      <Collapse
        defaultExpanded
        label={t('pageProperty.owners.modal.commissionSettings')}
        variant="card"
      >
        <TextField
          name="owner.agencyCommissionRate"
          label={t('pageProperty.owners.modal.agencyCommissionRate')}
          colSmInput={8}
          colSmLabel={4}
          rightAddons={['%']}
          type="number"
          min={0}
          max={100}
          rightTooltip={t(
            'pageProperty.owners.modal.agencyCommissionRateTooltip',
          )}
          required
        />
      </Collapse>
    </fieldset>
  );
};

export default CommissionFields;
